export default __webpack_public_path__ + "static/media/icon01.0b2843dd.png";